import React, { Component } from 'react';
import {
  Box,
  BrochureSection,
  Content,
  Heading,
  FormBox,
  ValidationError,
  BrokerApplicationNavigation,
  NavigationButton,
  Divider,
  ErrorMessage,
} from '../components/StyledComponents/StyledComponents';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { change, Field, getFormValues, reduxForm } from 'redux-form';
import { actions } from '../redux/brochureActions';
import { Col, ControlLabel, Form, FormGroup, Row } from 'react-bootstrap';
import { ButtonGroup } from '../components/PublicButtonGroup/PublicButtonGroup';
import styled from 'styled-components';
import {
  FormGroupInput,
  FormGroupTextArea,
} from '../../../common/form/components/components';

import { email, required } from 'redux-form-validators';
import { Link } from 'react-router';

const isRequired = required({ message: 'Required' });
const isEmail = email({ message: 'Valid Email Address is Required' });

const FORM_NAME = 'WorkingWithUsForm';
const LabelSpan = styled.span`
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: normal;
`;
const QuestionRow = styled(Row)`
  margin-bottom: 10px;
`;
const ContactForm = styled.div`
  display: block;
`;

const ClickLink = styled.a`
  color: #F8444F;
`;

const Text = styled.p`
    font-size: 16px
`;

const ValidationState = ({ showError, children }) => {
  return <ValidationError showError={showError}>{children}</ValidationError>;
};

const BusinessTypeButtonGroup = ({ meta, input }) => (
  <QuestionRow>
    <Col sm={4}>
      <ControlLabel style={{ height: '60px', display: 'flex' }}>
        <LabelSpan>What partnership would you like to apply for?</LabelSpan>
      </ControlLabel>
    </Col>
    <Col sm={8}>
      <ValidationState showError={meta.touched && meta.error}>
        <Field
          name={input.name}
          component={ButtonGroup}
          options={[
            {
              label: 'Travel Agent',
              value: 'travel_agent',
            },
            {
              label: 'General Affiliate',
              value: 'general_affiliate',
            },
          ]}
          validate={isRequired}
        />
        {meta.touched && meta.error && <ErrorMessage>{meta.error}</ErrorMessage>}
      </ValidationState>
    </Col>
  </QuestionRow>
);

class WorkingWithUsContainer extends Component {
  state = {
    partnerFormSubmitted: false,
    references: null,
  };

  sendForm = (values) => {
    const { actions } = this.props;
    Promise.resolve(actions.saveWorkingWithUsForm(values)).then((reference) => {
      this.setState({
        reference: reference,
        partnerFormSubmitted: true,
      });
    });
  };

  render() {
    const { handleSubmit, isSubmitting } = this.props;
    const { partnerFormSubmitted } = this.state;
    return (
      <BrochureSection>
        <ContactForm>
          <Form onSubmit={handleSubmit(this.sendForm)}>
            <Content>
              <Box>
                <FormGroup>
                  <Col sm={12}>
                    <Heading>Working With Us</Heading>
                  </Col>
                </FormGroup>

                {!partnerFormSubmitted ? (
                  <>
                    <FormBox>
                      <Row>
                        <Col sm={12}>
                          <Text>
                            If you are interested in working with us as an Affiliate or
                            Travel Agent, please fill out the form below and someone will
                            be in touch shortly.
                          </Text>
                        </Col>
                      </Row>

                      <Field
                        name={'data.attributes.business_type'}
                        labelSize={4}
                        colSize={8}
                        component={BusinessTypeButtonGroup}
                        validate={isRequired}
                        label={'Business Type'}
                      />

                      <Field
                        name={'data.attributes.first_name'}
                        labelSize={4}
                        colSize={8}
                        component={FormGroupInput}
                        validate={isRequired}
                        label={'First Name'}
                      />

                      <Field
                        name={'data.attributes.last_name'}
                        labelSize={4}
                        colSize={8}
                        component={FormGroupInput}
                        validate={isRequired}
                        label={'Last Name'}
                      />
                      <Field
                        name={'data.attributes.company'}
                        labelSize={4}
                        colSize={8}
                        component={FormGroupInput}
                        validate={isRequired}
                        label={'Company Name'}
                      />
                      <Field
                        name={'data.attributes.email'}
                        labelSize={4}
                        colSize={8}
                        component={FormGroupInput}
                        label={'Email Address'}
                        validate={isEmail}
                      />
                      <Field
                        name={'data.attributes.phone'}
                        labelSize={4}
                        colSize={8}
                        component={FormGroupInput}
                        label={'Telephone Number'}
                        validate={isRequired}
                      />
                      <Field
                        name={'data.attributes.message'}
                        labelSize={4}
                        colSize={8}
                        component={FormGroupTextArea}
                        validate={isRequired}
                        label={'Your Comments'}
                      />

                      <Divider />
                      <Row>
                        <Col sm={12}>
                          <Text>
                            If you would like to work with us as an Insurance Broker
                            instead please{' '}
                            <ClickLink href={'https://admin.aneevo.com/broker/application'} target={'_blank'}>click here</ClickLink> to
                            fill out our Application form.
                          </Text>
                        </Col>
                      </Row>
                    </FormBox>
                    <BrokerApplicationNavigation>
                      <NavigationButton type="submit" disabled={isSubmitting}>
                        Submit
                      </NavigationButton>
                    </BrokerApplicationNavigation>
                  </>
                ) : (
                  <FormBox>
                    <h1>Thank you for submitting you enquiry </h1>
                    <Text>
                      Thank you for your enquiry, our Partnerships Team will contact you
                      shortly. Please call us on 0800 458 0466 or email us on
                      brokers@justtravelcover.com if you have any further queries.
                    </Text>
                  </FormBox>
                )}
              </Box>
            </Content>
          </Form>
        </ContactForm>
      </BrochureSection>
    );
  }
}

export default compose(
  connect(
    (state) => ({
      formValues: getFormValues(FORM_NAME)(state),
      isSubmitting: state.brochure.isSubmitting,
    }),
    (dispatch) => ({
      actions: bindActionCreators(actions, dispatch),
      change: bindActionCreators(change, dispatch),
    }),
  ),
  reduxForm({ form: FORM_NAME }),
)(WorkingWithUsContainer);
